<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="damagelistForm">
      <div class="">
        <h3 class="form_name">DamageList</h3>

        <div class="input">
          <label for="">ItemName</label>
          <input
            type="text"
            class="default_input reference-form"
            formControlName="ItemName"
          />
        </div>

        <div class="input">
          <label for="">OptApprovedRate</label>
          <input
            type="number"
            class="default_input reference-form"
            formControlName="OptApprovedRate"
          />
        </div>

        <div class="input">
          <label for="">CompanyApprovedRate</label>
          <input
            type="number"
            class="default_input reference-form"
            formControlName="CompanyApprovedRate"
          />
        </div>

        <div class="input">
          <label for="">MeasureName</label>
          <select
            name=""
            class="default_input reference-form"
            (change)="onSelectMeasureName($event.target.value)"
            formControlName="MeasureId"
          >
            <option *ngFor="let measure of measures" [value]="measure.id">{{
              measure.MeasureName
            }}</option>
          </select>
        </div>
        <div class="input">
          <label for="">UomName</label>
          <select
            name=""
            class="default_input reference-form"
            formControlName="UomId"
          >
            <option *ngFor="let uom of uoms" [value]="uom.id">{{
              uom.UomName
            }}</option>
          </select>
        </div>
        <div class="input">
          <label for="">DamageStatusName</label>
          <select
            name=""
            class="default_input reference-form"
            formControlName="DamageStatusId"
          >
            <option
              *ngFor="let damagestatus of damagestatuss"
              [value]="damagestatus.id"
              >{{ damagestatus.DamageStatusName }}</option
            >
          </select>
        </div>

        <div class="btn_holder">
          <button
            class="default_primary-button"
            *ngIf="selectedIndex === null"
            (click)="addNew(damagelistForm.value)"
          >
            Add
          </button>
          <button
            class="default_primary-button"
            *ngIf="selectedIndex !== null"
            (click)="addNew(damagelistForm.value)"
          >
            Update
          </button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">
            Reset
          </button>
        </div>
      </div>
    </form>
    <div class="display_table">
      <div class="search_container">
        <input
          type="text"
          class="default_input search"
          placeholder="Search for ItemType"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
        />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container
              *ngIf="itemtypes | filterReference: control.value as result"
            >
              <app-option
                (click)="selectItemType(option.id)"
                *ngFor="let option of result"
                [value]="option.ItemTypeName"
              >
                {{ option.ItemTypeName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length"
                >No result...</app-option
              >
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head">
        <span class="item">S/N</span>
        <span class="item">Item Name</span>
        <span class="item">Opt Approved Rate</span>
        <span class="item">Company Approved Rate</span>
        <span class="item">Measure</span>
        <span class="item">Uom</span>
        <span class="item">DamageStatus</span>
        <span class="item">Action</span>
      </div>

      <div class="scroll"></div>
      <div class="body_content" *ngIf="status">
        <div
          class="the_body"
          *ngFor="
            let damagelist of damagelistFormArray.get('DamageLists')[
              'controls'
            ];
            index as i
          "
          (click)="onEdit(i, damagelist.value)"
          style="cursor: pointer;"
          matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{ i + 1 }}</span>
          <span class="content">{{ damagelist?.value.ItemName }}</span>
          <span class="content">{{ damagelist?.value.OptApprovedRate }}</span>
          <span class="content">{{ damagelist?.value.CompanyApprovedRate }}</span>
          <span class="content">{{
            getMeasureName(damagelist?.value.MeasureId)
          }}</span>
          <span class="content">{{ getUomName(damagelist?.value.UomId) }}</span>
          <span class="content">{{
            getDamageStatusName(damagelist?.value.DamageStatusId)
          }}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
              class="delete_icon trash"
              (click)="deleteDamageList(i, damagelist.value)"
            >
              <em class="ti-trash"> </em> 
            </button>
          </span>
        </div>
      </div>
      <div class="btn_holder">
        <button
          class="default_primary-button"
          (click)="onSubmit(damagelistFormArray.value)"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
